function TermsPage() {
  return (
    <div className="compliance-page-route">
      <div className="compliance-page">
        <div className="compliance-shell compliance-shell-narrow">
          <header className="compliance-hero">
            <div className="compliance-eyebrow">Galaxy Access</div>
            <h1 className="compliance-title">Terms & Conditions</h1>
            <p className="compliance-copy">
              These Terms & Conditions apply to SMS communications sent by Galaxy Access for
              customer care, service-related conversations, account notifications, and operational
              communications.
            </p>
          </header>

          <section className="compliance-card compliance-article">
            <h2>SMS Consent Terms</h2>
            <p>
              By providing your phone number and separately opting in, you agree to receive SMS
              messages from Galaxy Access.
            </p>
            <p>
              Messages may include customer support responses, appointment reminders, service
              notifications, order and delivery updates, verification codes, and account-related
              notifications.
            </p>
            <p>
              Message frequency varies based on your requests, account activity, and ongoing service
              needs. Message and data rates may apply.
            </p>
            <p>
              You may reply STOP at any time to opt out of future SMS communications. You may reply
              HELP for assistance.
            </p>
            <p>
              Consent to receive SMS messages from Galaxy Access is optional and is not a condition
              of purchasing any product or receiving any service.
            </p>
            <p>
              Additional information about how phone numbers and SMS consent data are collected and
              handled is available in our{' '}
              <a href="https://voip.galaxyaccess.us/privacy">Privacy Policy</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
